import { gameService } from '../gameService';

import { parseQuery } from '../../core/helpers/parseQuery';
import { socketGamePath } from '../../core/constants/gameConfigsAndUrls';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { GameLiveConnection } from '../../core/classes/gameLiveConnection';
import { DefaultQueryParams, LicenseTypes } from '../../core/constants/defaultQueryParams';
import { GameLiveConnectionMethod } from '../../core/constants/connectionTypes';

import { GameModes } from '../../core/constants/gameModes';

const {
  [DefaultQueryParams.PartnerId]: partnerId,
  [DefaultQueryParams.GameId]: gameId,
  [DefaultQueryParams.TournamentId]: tournamentid,
  [DefaultQueryParams.Mode]: mode,
  [DefaultQueryParams.LicenseType]: licenseType,
} = parseQuery(window.location.search);

class GameConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    if (isFirst) {
      this.executeConnections();
    }
    await this.sendInitial();
  }

  async sendInitial() {
    await super.sendGetInitialState({
      partnerId,
      gameId,
      tournamentid,
      isDemo: mode === GameModes.Fun,
    });
  }

  handleInitialResult(data) {
    if (!data) {
      setTimeout(() => {
        super
          .sendGetInitialState({ partnerId, gameId, isDemo: mode === GameModes.Fun })
          .then(() => {});
      }, 500);
    } else {
      gameService.onGetInitialStateResult.call(gameService, data);
    }
  }

  Spin(model) {
    super.on('Spin', model);
  }

  SpinResult(resultData) {
    super.on('SpinResult', resultData);
  }

  sendPing() {
    super.invoke('Ping');
  }

  getPong() {}

  getBalance() {
    return super.invoke(GameLiveConnectionMethod.GetBalance);
  }

  getTournamentBalance(...params) {
    return super.invoke(GameLiveConnectionMethod.GetTournamentBalance, ...params);
  }

  sendGamble(model) {
    this.gamble(model);
  }

  doSpinCollect(model) {
    this.spinCollect(model);
  }

  doSpin(spinModel) {
    this.spin(spinModel);
  }

  executeConnections() {
    super.onGetInitialStateResult(this.handleInitialResult.bind(this));

    // Spin
    super.onSpinResult(gameService.handleSpinResult.bind(gameService));
    // super.onDemoSpinResult(gameService.handleSpinResult.bind(gameService));

    // Free bet
    super.onFreeBetAwarded(gameService.handleFreeBetAwarded.bind(gameService));

    // BoostedJackpot
    super.onGetBoostedJackpotWinResult(gameService.handleBoostedJackpotWinResult.bind(gameService));

    // Jackpot
    super.onJackpotSceneResult(gameService.handleJackpotSceneResult.bind(gameService));
    super.onJackpotSceneItemResult(gameService.handleJackpotSceneItemResult.bind(gameService));

    // Gamble
    super.onGambleResult(gameService.handleGambleResult.bind(gameService));
    // super.onDemoGambleResult(gameService.handleGambleResult.bind(gameService));
    super.onSpinCollectResult(gameService.handleSpinCollectResult.bind(gameService));
    // super.onDemoSpinCollectResult(gameService.handleSpinCollectResult.bind(gameService));

    // Tournament
    super.onTournamentInfoResult(gameService.handleTournamentInfoResult.bind(gameService));

    // Core events
    super.onPing(this.getPong);
    super.onClose();
    super.onGameOpen();
    super.onReconnected();
    super.onReconnecting();
    super.onBalanceUpdate();
    super.onTournamentBalanceUpdate();
    super.onMaintenanceNotify();
  }
}

const { socketUrl } = environmentBuilder(+licenseType === LicenseTypes.brazilianGlI);

const url = (path) => ({ url: `${socketUrl}${path}` });

export const gameLiveConnection = new GameConnection(url(socketGamePath));
